import React, { useEffect, useState } from "react";
import { useLocation, useRoutes } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { routes } from "./router/routes";
import Header from "./components/header/Header";
import Aside from "./components/aside/Aside";
import PopUpWindow from "./components/pop-up/PopUpWindow";
import { useSelector } from "react-redux";
import { getLanguages } from "./axios/api/languagesApi";
import { selectIsOpenModal } from "./redux/slices/popUpSlice";
import OrderModal from "./components/modal/OrderModal";

function AppWrapper() {
  const location = useLocation();
  const element = useRoutes(routes);
  const isOpenPopUp = useSelector(selectIsOpenModal);
  const [isModalHasData, setIsModalHasData] = useState(null);
  const [fontClass, setFontClass] = useState("font-roboto");
  const { i18n } = useTranslation();

  useEffect(() => {
    const supportedLangs = ["en", "am", "ru"];
    const storedLang = localStorage.getItem("partnerAdminLng");
    const pathSegments = location.pathname.split("/");
    const urlLang = pathSegments[1];

    let finalLang;

    if (urlLang && supportedLangs.includes(urlLang)) {
      finalLang = urlLang;
    } else if (storedLang && supportedLangs.includes(storedLang)) {
      finalLang = storedLang;
    } else {
      finalLang = "am";
    }

    localStorage.setItem("partnerAdminLng", finalLang);

    i18n.changeLanguage(finalLang);

    setFontClass(finalLang === "am" ? "font-mardato" : "font-roboto");
  }, [location.pathname, i18n]);

  useEffect(() => {
    const fetchTranslations = async () => {
      try {
        const res = await getLanguages();

        Object.entries(res).forEach(([lng, translations]) => {
          i18n.addResources(lng, "translation", translations);
        });
      } catch (error) {
        console.error(error);
      }
    };

    const lang = localStorage.getItem("i18nextLng");
    if (lang) {
      i18n.changeLanguage(lang);
    } else {
      i18n.changeLanguage("am");
      // window.location.reload();
    }

    try {
      fetchTranslations();
    } catch (error) {
      console.error(error);
    }
  }, []);

  const protectedPaths = [
    "dashboard",
    "services",
    "statistics",
    "orders",
    "settings",
    "calendar",
    "finances",
  ];

  const pathSegments = location.pathname.split("/");
  const currentPage = pathSegments[2];

  const shouldShowHeaderAndAside =
    ["en", "am", "ru"].includes(pathSegments[1]) &&
    protectedPaths.includes(currentPage) &&
    pathSegments.length === 3;

  return (
    <div
      className={`App ${fontClass} text-secondary_black dark:text-white transition-colors duration-500`}
    >
      <div className="flex">
        {shouldShowHeaderAndAside && <Aside />}
        <div className="flex flex-col flex-1">
          {shouldShowHeaderAndAside && (
            <div className="mx-6">
              <Header />
            </div>
          )}

          {isOpenPopUp && <PopUpWindow />}
          {isModalHasData && (
            <OrderModal
              onClose={() => setIsModalHasData(null)}
              rowData={isModalHasData}
            />
          )}

          <div className="pb-[160px] pt-[9em] md:pt-[9em] md:pb-0">{element}</div>
        </div>
      </div>
    </div>
  );
}

export default AppWrapper;
